import { Schema } from '../types'
import { criticalIssueSchema } from './critical_issue'
import { criticalIssueData } from './critical_issue.data'
import {
  dbtimeByKVRequestSchema,
  dbtimeBySQLPhaseSchema,
  dbtimeBySQLTypeSchema,
  dbtimeSchema
} from './database_time'
import {
  dbtimeByKVRequestData,
  dbtimeBySQLPhaseData,
  dbtimeBySQLTypeData,
  dbtimeData
} from './database_time.data'
import { brBackupSchema } from './load_profile/br_backup'
import { brBackupData } from './load_profile/br_backup.data'
import { cboSchema } from './load_profile/cbo'
import { cboData } from './load_profile/cbo.data'
import { connectionSchema } from './load_profile/connection'
import { connectionData } from './load_profile/connection.data'
import { ddlSchema } from './load_profile/ddl'
import { ddlData } from './load_profile/ddl.data'
import { gcProgressSchema } from './load_profile/gc_progress'
import { gcProgressData } from './load_profile/gc_progress.data'
import {
  backgroundEventSchema,
  clientRequestSchema,
  cpsSchema,
  profileOthersSchema,
  qpsSchema,
  seasonalitySchema,
  tikvRequestSchema
} from './load_profile/load_profile'
import {
  backgroundEventData,
  clientReqeustData,
  cpsData,
  profileOthersData,
  qpsData,
  seasonalityData,
  tikvRequestData
} from './load_profile/load_profile.data'
import { pdSchduleSchema } from './load_profile/pd_schedule'
import { pdScheduleData } from './load_profile/pd_schedule.data'
import { rocksdbKVSchema } from './load_profile/rocksdb_kv'
import { rocksdbKVData } from './load_profile/rocksdb_kv.data'
import { rocksdbRaftSchema } from './load_profile/rocksdb_raft'
import { rocksdbRaftData } from './load_profile/rocksdb_raft.data'
import { scaleInoutSchema } from './load_profile/scale_inout'
import { scaleInoutData } from './load_profile/scale_inout.data'
import { transactionSchema } from './load_profile/transaction'
import { transactionData } from './load_profile/transaction.data'
import { coprocessorSchema } from './module_status/coprocessor'
import { coprocessorData } from './module_status/coprocessor.data'
import { errorSchema } from './module_status/error'
import { errorData } from './module_status/error.data'
import { ioLatencySchema } from './module_status/io_latency'
import { ioLatencyData } from './module_status/io_latency.data'
import { pdTsoSchema } from './module_status/pd_tso'
import { pdTsoData } from './module_status/pd_tso.data'
import { raftstoreSchema } from './module_status/raftstore'
import { raftstoreData } from './module_status/raftstore.data'
import { rocksdbRWKVSchema } from './module_status/rocksdb_rw_kv'
import { rocksdbRWKVData } from './module_status/rocksdb_rw_kv.data'
import { rocksdbRWRaftSchema } from './module_status/rocksdb_rw_raft'
import { rocksdbRWRaftData } from './module_status/rocksdb_rw_raft.data'
import { rocksdbRWRaftEngineSchema } from './module_status/rocksdb_rw_raft_engine'
import { rocksdbRWRaftEngineData } from './module_status/rocksdb_rw_raft_engine.data'
import { schedulerSchema } from './module_status/scheduler'
import { schedulerData } from './module_status/scheduler.data'
import { snapshotSchema } from './module_status/snapshot'
import { snapshotData } from './module_status/snapshot.data'
import { sqlSchema } from './module_status/sql'
import { sqlData } from './module_status/sql.data'
import { otherViewSchema } from './other_view'
import { otherViewData } from './other_view.data'
import { resourceInfoSchema } from './resource_status/info'
import { resourceInfoData } from './resource_status/info.data'
import { regionCountSchema } from './resource_status/region_count'
import { regionCountData } from './resource_status/region_count.data'
import { threadCPUSchema } from './resource_status/thread_cpu'
import { threadCPUData } from './resource_status/thread_cpu.data'
import { topLevelSchema } from './top_level'
import { topLevelData } from './top_level.data'

export interface Table {
  schema: Schema
  data?: { [k: string]: any }[]
}

export const tables: Table[] = [
  { schema: topLevelSchema, data: topLevelData },
  { schema: dbtimeSchema, data: dbtimeData },
  { schema: dbtimeBySQLTypeSchema, data: dbtimeBySQLTypeData },
  { schema: dbtimeBySQLPhaseSchema, data: dbtimeBySQLPhaseData },
  { schema: dbtimeByKVRequestSchema, data: dbtimeByKVRequestData },
  { schema: { title: 'Load Profile' } },
  { schema: seasonalitySchema, data: seasonalityData },
  { schema: { title: 'Source Breakdown', level: 1 } },
  { schema: qpsSchema, data: qpsData },
  { schema: clientRequestSchema, data: clientReqeustData },
  { schema: tikvRequestSchema, data: tikvRequestData },
  { schema: cpsSchema, data: cpsData },
  { schema: profileOthersSchema, data: profileOthersData },
  { schema: transactionSchema, data: transactionData },
  { schema: connectionSchema, data: connectionData },
  { schema: backgroundEventSchema, data: backgroundEventData },
  { schema: gcProgressSchema, data: gcProgressData },
  { schema: cboSchema, data: cboData },
  { schema: brBackupSchema, data: brBackupData },
  { schema: pdSchduleSchema, data: pdScheduleData },
  { schema: scaleInoutSchema, data: scaleInoutData },
  { schema: ddlSchema, data: ddlData },
  { schema: { title: 'On-going Compaction', level: 2 } },
  { schema: rocksdbKVSchema, data: rocksdbKVData },
  { schema: rocksdbRaftSchema, data: rocksdbRaftData },
  { schema: { title: 'Module Status' } },
  { schema: sqlSchema, data: sqlData },
  { schema: { title: 'TiKV', level: 1 } },
  { schema: ioLatencySchema, data: ioLatencyData },
  { schema: coprocessorSchema, data: coprocessorData },
  { schema: schedulerSchema, data: schedulerData },
  { schema: snapshotSchema, data: snapshotData },
  { schema: raftstoreSchema, data: raftstoreData },
  { schema: { title: 'RocksDB(kv/raft) read/write', level: 2 } },
  { schema: rocksdbRWKVSchema, data: rocksdbRWKVData },
  { schema: rocksdbRWRaftSchema, data: rocksdbRWRaftData },
  { schema: rocksdbRWRaftEngineSchema, data: rocksdbRWRaftEngineData },
  { schema: errorSchema, data: errorData },
  { schema: pdTsoSchema, data: pdTsoData },
  { schema: { title: 'Resource Status' } },
  { schema: resourceInfoSchema, data: resourceInfoData },
  { schema: threadCPUSchema, data: threadCPUData },
  { schema: regionCountSchema, data: regionCountData },
  { schema: criticalIssueSchema, data: criticalIssueData },
  { schema: { title: 'Other Views[manual]' } },
  { schema: otherViewSchema, data: otherViewData },
  { schema: { title: 'Alerts Summary', level: 1 } },
  { schema: { title: 'Top SQL analyze', level: 1 } },
  { schema: { title: 'Triage History(if any)', level: 1 } }
]
